export class EnvService {
  // The values that are defined here are the default values that can
  // be overridden by env.js

  // API url
  public apiUrl = '';

  // Notification API url
  public notificationApiURL = '';

  // Razorpay Details
  companyImageURL = '';
  razorpayKey = '';
  merchantEmailID = '';
  merchantBrandColor = '';
  merchantCompanyName = '';
  merchantCompanyDescription = '';
  merchantCompanyAddress = '';

  // Whether or not to enable debug mode
  public enableDebug = true;

  // Export excel author name  
  public excelAuthorName = '';

  constructor() {
  }
}